module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00e_foreword#forword"
    }
  }, [_vm._v("Foreword by Todd Pownell")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00f_introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00g_part1#part1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 1")]), _vm._v(" Outfitting the Jeweler’s Studio")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 1 "), _c('strong', [_vm._v("Planning the Layout of the Studio")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec1"
    }
  }, [_vm._v("Space Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec2"
    }
  }, [_vm._v("Choosing a Location")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec3"
    }
  }, [_vm._v("Planning the Work Area")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec4"
    }
  }, [_vm._v("Environmental and Safety Concerns")])]), _vm._v(" "), _c('p', {
    staticClass: "chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 2 "), _c('strong', [_vm._v("Jeweler’s Studio Tools")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec1"
    }
  }, [_vm._v("Furnishing Your Studio")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec2"
    }
  }, [_vm._v("Workbenches")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec3"
    }
  }, [_vm._v("Hand Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec4"
    }
  }, [_vm._v("Forming Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec5"
    }
  }, [_vm._v("Basic Studio Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec6"
    }
  }, [_vm._v("Soldering Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec7"
    }
  }, [_vm._v("Advanced Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec8"
    }
  }, [_vm._v("Optional Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 3 "), _c('strong', [_vm._v("Metal and Other Materials")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Properties of Metal")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selecting Metal")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soldering Process")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sid01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Technique: Soldering")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sid02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Technique: Drilling")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sid03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Technique: Sawing")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sid04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Technique: Filing")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03sid05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Technique: Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working with Other Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Properties of Stones and Unusual Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 4 "), _c('strong', [_vm._v("Mechanics, Contraptions, and Surface Treatments")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Connections")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Settings")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contraptions")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enclosures")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surface Treatments: Patinas, Textures, and Finishes")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Riveted Bead Ring")]), _vm._v(", "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 104")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 2")]), _vm._v(" In the Jeweler’s Studio: The Projects")])])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Band Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Chased Bangle")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concave and Convex Cufflinks")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riveted Bead Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chain Making")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chunky Bead Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bezel-Set Pendant")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cage Pendant")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open-Band Copper Bracelet")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chunky Stone Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glass Brooch")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No-Solder Bracelet")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom Earrings")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#part02lev1sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wire-Worked Earrings")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06_bm00#bm00",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "chap4"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("APPENDIX")]), _vm._v(" "), _c('strong', [_vm._v("Beyond the Studio")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap4"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_bm02#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pursuing Your Career in Jewelry")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_bm03#bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_bm04#bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11_index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_bm05#bm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artist Directory")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_bm06#bm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14_bm07#bm07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Open-Band Copper Bracelet")]), _vm._v(", "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part02#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 128")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_c('em', [_vm._v("Photo: Dan Fox")])]), _vm._v(" "), _c('p', {
    staticClass: "captiona"
  }, [_c('strong', [_vm._v("Artist")]), _vm._v(": Todd Pownell"), _c('br'), _c('strong', [_vm._v("Title")]), _vm._v(": Hidden Halo"), _c('br'), _c('strong', [_vm._v("Materials")]), _vm._v(": Diamonds, gold, sterling, aquamarine, sapphire"), _c('br'), _c('strong', [_vm._v("Techniques")]), _vm._v(": Fabricated, constructed, soldered, fused")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Creation is existent within a critical region of material, thought, and process. All is passing. Meaning cannot be suspended and tension is always present. Jewelry objects have a powerful residue of emotion. Still, everything becomes thin and the ideal object remains thought undefined.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e95697","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00d_content.vue
// module id = 66
// module chunks = 0